"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const react_helmet_1 = __importDefault(require("react-helmet"));
const SelectCheckbox_1 = __importDefault(require("../SelectCheckbox"));
const Button_1 = __importDefault(require("../../forms/Button"));
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const List = ({ match }) => {
    const { path } = match;
    const [orders, setOrders] = (0, react_1.useState)([]);
    const ordersApi = new api_1.OrdersApi();
    const [isCheckAll, setIsCheckAll] = (0, react_1.useState)(false);
    const [isCheck, setIsCheck] = (0, react_1.useState)([]);
    const aggregateQuery = () => {
        const params = new URLSearchParams();
        isCheck.forEach(v => params.append('id', v));
        return params.toString();
    };
    const handleSelectAll = (e) => {
        setIsCheckAll(!isCheckAll);
        setIsCheck(orders.map(li => li.id));
        if (isCheckAll) {
            setIsCheck([]);
        }
    };
    const handleClick = e => {
        const { checked } = e.target;
        const id = Number(e.target.id);
        setIsCheck([...isCheck, id]);
        if (!checked) {
            setIsCheck(isCheck.filter(item => item !== id));
        }
    };
    (0, react_1.useEffect)(() => {
        const fetchItems = async () => {
            const { items, active_order } = await ordersApi.index({ only_finished: true });
            setOrders(items);
        };
        fetchItems();
    }, []);
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Orders")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Bestellhistorie")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Button_1.default, { disabled: isCheck.length === 0 },
                    react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/aggregate?` + aggregateQuery(), className: (0, classnames_1.default)({ 'disabled-link': isCheck.length === 0 }) }, "Aggregierte Historie")))),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" },
                react_1.default.createElement("div", { className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" },
                    react_1.default.createElement("div", { className: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" },
                        react_1.default.createElement("table", { className: "min-w-full divide-y divide-gray-200" },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/6" },
                                        react_1.default.createElement("a", { onClick: handleSelectAll, className: 'cursor-pointer' },
                                            react_1.default.createElement(SelectCheckbox_1.default, { type: "checkbox", name: 'orders', id: 'orders-all', handleClick: handleSelectAll, isChecked: isCheckAll }),
                                            "\u00A0Alle")),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "NR."),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Name"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "BESTELLTERMIN"),
                                    react_1.default.createElement("th", { scope: "col", className: "px-6 py-3 bg-gray-50" },
                                        react_1.default.createElement("span", { className: "sr-only" })))),
                            react_1.default.createElement("tbody", null, orders.map((order) => (react_1.default.createElement("tr", { key: order.id, className: "bg-white" },
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement("div", { className: 'px-6' },
                                        react_1.default.createElement(SelectCheckbox_1.default, { type: "checkbox", name: 'orders', id: order.id, handleClick: handleClick, isChecked: isCheck.includes(order.id) }))),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, order.id),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }, order.name),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }, moment_1.default.utc(order.expires_at).local().format("DD.MM.YYYY, HH:mm")),
                                react_1.default.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" },
                                    react_1.default.createElement(react_router_dom_1.Link, { to: `${path}/${order.id}`, className: "text-primary-600 hover:text-primary-900" }, "Historie")))))))))))));
};
exports.default = List;
